import { FETCH_TAXONOMY} from '../constants/actionTypes'
import deepmerge from 'deepmerge'

const initialState = {
  downloads: [],
  news: [],
  projects: [],
  projects_status: []
};

export default (state = initialState, action) => {
  switch(action.type) {
    case FETCH_TAXONOMY: 
		return deepmerge(state, action.payload);
    default : 
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/taxonomyReducer.js